import { config } from "@/config";
import electiStudioSrc from "@/images/electi-studio-logo.png";
import itcSrc from "@/images/itc-white.svg";
import { Image } from "@/ui/image";
import { Link } from "@/ui/link";
import { interactiveTextWhite } from "@/ui/utils.css";
import { copyrightRange, ExternalLink, useCurrentUser } from "@indietabletop/appkit";
import { hrefs } from "../root-layout/fmt";
import * as css from "./style.css";

function getReleaseIdentifier() {
  const shortcode = config.COMMIT_SHORTCODE;
  const branch = config.BRANCH;

  if (!shortcode || !branch) {
    return "[local]";
  }

  return shortcode + (branch !== "main" ? ` (${branch})` : "");
}

function LegalSection() {
  const Electi_Studio_LLC = (
    <ExternalLink
      href="https://www.electi-studio.com/?utm_source=indietabletopclub&utm_medium=hobgoblinbattlegen"
      className={css.legalLink}
    >
      Electi Studio LLC
    </ExternalLink>
  );

  const Indie_Tabletop_Club = (
    <ExternalLink className={css.legalLink} href={hrefs.itc()}>
      Indie Tabletop Club
    </ExternalLink>
  );

  const copyright = copyrightRange(2023);

  return (
    <p className={css.legalParagraph}>
      All text from “Hobgoblin” by Mike Hutchinson {copyright} {Electi_Studio_LLC}. All rights
      reserved. Used with permission. App development and code {copyright} {Indie_Tabletop_Club}.
      All rights reserved. Release {getReleaseIdentifier()}.
    </p>
  );
}

export function Footer() {
  const isLoggedIn = !!useCurrentUser();

  return (
    <div className={css.footer}>
      <div className={css.links}>
        <Link className={interactiveTextWhite} href="/changelog">
          Changelog
        </Link>

        <span className={css.middot}> · </span>

        <Link className={interactiveTextWhite} href="/help">
          Help
        </Link>

        <span className={css.middot}> · </span>

        <ExternalLink
          className={interactiveTextWhite}
          href="https://trello.com/b/LjbD3ZBN/hobgoblin"
        >
          Roadmap
        </ExternalLink>

        <span className={css.middot}> · </span>

        <ExternalLink className={interactiveTextWhite} href="https://discord.gg/g9Cugahmgq">
          Discord
        </ExternalLink>

        <span className={css.middot}> · </span>

        {!isLoggedIn ?
          <Link className={interactiveTextWhite} href="/login">
            Log in
          </Link>
        : <Link className={interactiveTextWhite} href="/account">
            Account
          </Link>
        }
      </div>

      <div className={css.legal}>
        <div className={css.logos}>
          <ExternalLink
            className={css.logoLink}
            href="https://www.electi-studio.com/?utm_source=indietabletopclub&utm_medium=hobgoblinbattlegen"
          >
            <Image
              src={electiStudioSrc}
              alt="Electi Studio"
              width={638}
              height={136}
              className={css.electiStudioImage}
            />
          </ExternalLink>
          <ExternalLink className={css.logoLink} href={hrefs.itc({ content: "footer_logo" })}>
            <Image
              src={itcSrc}
              alt="Indie Tabletop Club"
              width={194}
              height={12}
              className={css.itcImage}
            />
          </ExternalLink>
        </div>

        <p className={css.legalParagraph}>
          {"This app uses no tracking, other than anonymous, GDPR-compliant "}
          <ExternalLink href="https://usefathom.com" className={css.legalLink}>
            Fathom Analytics
          </ExternalLink>
          {". For more information, see our "}
          <ExternalLink href={hrefs.terms({ content: "footer" })} className={css.legalLink}>
            Terms of Service
          </ExternalLink>
          {", "}
          <ExternalLink href={hrefs.privacy({ content: "footer" })} className={css.legalLink}>
            Privacy Policy
          </ExternalLink>
          {", and "}
          <ExternalLink href={hrefs.cookies({ content: "footer" })} className={css.legalLink}>
            Cookie Policy
          </ExternalLink>
          {"."}
        </p>

        <LegalSection />
      </div>
    </div>
  );
}
